import { useLocation } from 'react-router-dom';

/**
 * Hook to check if the current route is the media library
 * @returns boolean - true if current route is media library, false otherwise
 */
export const useIsMediaLibrary = (): boolean => {
  const location = useLocation();
  return location.pathname === '/media-library';
}; 